class FilterSearch extends HTMLElement {
  input; values; parent;
  
  connectedCallback() {
    this.input = this.querySelector('input');
    this.parent = document.querySelector(this.dataset.parent);
    if(this.parent !== null) {
      this.values = this.parent.querySelectorAll('[data-value]');
      this.input.addEventListener('input', () => this.search(this.input.value));
    }
  }

  search(str) {
    Array.from(this.values).forEach(el => {
      if(el.dataset.value.toLowerCase().includes(str.toLowerCase())) {
        el.classList.remove('d-none');
      } else {
        el.classList.add('d-none');
      }
    });
  }
}
if(!customElements.get('filter-search')) {
  customElements.define('filter-search', FilterSearch);
}